import type { MailboxInfo } from 'owa-client-types';
import type { SearchResultPersona, SearchPerson } from '../../data/schema/SubstrateSearchResponse';
import { logUsage } from 'owa-analytics';

export default function convertSearchResultPersonToSearchPersonType(
    searchResultPerson: SearchResultPersona,
    mailboxInfo: MailboxInfo
): SearchPerson | undefined {
    // Ensure required properties are present
    if (
        !searchResultPerson.Id ||
        !searchResultPerson.EmailAddresses ||
        searchResultPerson.EmailAddresses.length === 0 ||
        !searchResultPerson.ReferenceId
    ) {
        logUsage('SearchResultConversion_PersonType_MissingRequiredProperties', mailboxInfo, {
            missingId: !searchResultPerson.Id,
            missingEmailAddresses:
                !searchResultPerson.EmailAddresses ||
                searchResultPerson.EmailAddresses.length === 0,
            missingReferenceId: !searchResultPerson.ReferenceId,
        });
        return undefined;
    }

    return {
        ItemId: searchResultPerson.Id,
        name: searchResultPerson.DisplayName,
        officeLocation: searchResultPerson.OfficeLocation,
        role: searchResultPerson.JobTitle,
        email: searchResultPerson.EmailAddresses[0].toLowerCase(),
        InstanceKey: searchResultPerson.ReferenceId,
    };
}
